import { ReactElement, Suspense } from "react";
import App from "./App";
import SkeletonApp from "./components/skeletonApp";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { MsalProvider } from "@azure/msal-react";
import UnauthenticatedPage from "./unauthenticatedPage";
import { getMSALInstance, isAzureMode } from "./system/security";
import { AuthProvider } from "./context/authProvider";


const Routes = (): ReactElement => {

  if(!isAzureMode()) {
    return (
      <Suspense fallback={<SkeletonApp />}>
        <AuthProvider>
          <App/>
        </AuthProvider>
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<SkeletonApp />}>
      <MsalProvider instance={getMSALInstance()}>
        <AuthenticatedTemplate>
          <App/>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <UnauthenticatedPage/>
        </UnauthenticatedTemplate>
      </MsalProvider>
    </Suspense>
  );
};

export default Routes;
